<template>
	<md-field :class="[{ 'md-error': error }]">
		<label>{{ label }}</label>
		<TbSelect v-model="moduleValue"
				  :options="options"
				  options-value-field="key"
				  options-display-field="name"
				  @md-selected="onSelect"
				  :required="required"
				  :disabled="disabled"
		/>
		<span v-if="error" class="validation-error">{{ error }}</span>
	</md-field>
</template>
<script>

export default {
	props: {
		value: { type: String, default: null },
		label: { type: String },
		enumDef: { type: Object },
		filteredValues: { type: Array, default: null },
		error: { type: Boolean, default: "" },
		required: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false }
	},
	data() {
		return {
			moduleValue: null,
		};
	},
	mounted() {
		this.moduleValue = this.value;
	},
	computed: {
		filteredValueKeys() {
			return this.filteredValues ? this.filteredValues.map(val => val.toString()) : null;
		},
		options() {
			let enumOptions = Object.keys(this.enumDef.properties)
				.map(key => {
					return {
						key: key,
						name: this.$t(this.enumDef.properties[key].key)
					};
				});

			if (!this.filteredValueKeys) {
				return enumOptions;
			} else {
				return enumOptions
					.filter(option => this.filteredValueKeys.includes(option.key))
					.sort((o1, o2) => this.filteredValueKeys.indexOf(o1.key) - this.filteredValueKeys.indexOf(o2.key));
			}
		}
	},
	methods: {
		onSelect() {
			this.$emit("input", this.moduleValue);
		}
	},
	watch: {
		value() {
			this.moduleValue = this.value;
		}
	}
};
</script>
